import styled from 'styled-components';
import * as FiIcons from 'react-icons/fi';

export const Container = styled.div`
  content: 'Documents';
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 30px;
  min-height: 500px;
  svg {
    height: 18px
    width: 16px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const HeadingDocument = styled.h3`
  flex-direction: column;
  align-items: flex-end;
`;

export const HorizontalLine = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: black;
  margin-left: 15px;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  width: 100%;
  background-color: #fff;
  height: 80vh;
`;

export const PriceScrollableContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  max-height: 500px;
  gap: 20px;
  padding: 20px;
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const BenefitsSettingsWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 10px;
  select {
    margin-top: 12px;
  }
`;

export const FileUploadWrapper = styled.div`
  display: 'flex';
  background: #ffffff;
  display: flex;
  align-self: center;
  border-radius: 10px;
`;

export const FileUploadWrapperRemove = styled.div`
  display: flex;
  align-self: center;
  padding-right: 15px;
  &:hover {
    cursor: pointer;
  }
`;
export const TrashIcon = styled(FiIcons.FiTrash2)`
  pointer-events: none;
`;
export const FormWrapper = styled.div`
  display: flex;
  flex: 1;
`;
export const Input = styled.input`
  display: block;
  height: 35px;
  font-size: 1.4rem;
  color: #222247;
  border-radius: 7px;
  padding: 0 8px;
  border: 1px solid #dbdbdc;
  &:disabled {
    border: 1px solid transparent;
  }
`;
export const StyledErrorWrap = styled.p`
  font-size: 12px;
  font-weight: 400;
  padding: 0 16px;
  color: red;
`;
export const InputLabel = styled.div`
  color: '#222247';
`;

export const WarningText = styled.p`
  font-size: 12pt;
  color: rgba(214, 24, 11);
  margin: 8% 0 0 2%;
  span {
    font-family: sans-serif;
    font-size: 15pt;
    font-weight: bold;
  }
`;
export const FooterButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
`;

export const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
`;
